import { Component, OnInit, OnDestroy, NgZone, EventEmitter, ViewChild, Input } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { ProjectService, ToastrService, GlobalService, DeleteConfirmation } from './../../../../shared/index';

@Component({
    selector: 'project-list',
    templateUrl: './project-list.html',
    standalone: false
})

export class ProjectListComponent implements OnInit, OnDestroy {
    @ViewChild('ProjectPublish') modal: ModalDirective;
    @ViewChild('DeleteProjectConfirmation') ModelDeleteProject: ModalDirective;
    Is_Details_Show = false;
    //@ts-ignore
    All_Projects_With_Details: any[] = [];
    public subscriptions: Subscription[] = [];
    Selected_project_ID = 0;
    Project_ID = 0;
    Status: string;
    Project_Title: string;
    Is_Processing: boolean;
    ID: number;
    textColor: string | string[] | { [klass: string]: boolean } = '';
    constructor(
        private _toastrService: ToastrService,
        private _ProjectService: ProjectService,
        private _globalService: GlobalService,

    ) {
        this.subscriptions.push(this._globalService.deleteResultEx.subscribe((result: DeleteConfirmation) => {
            if (result.EntityType == 'Project Details' && result.Confirmed && result.EntityId == this.Project_ID) {
                return this._ProjectService.Delete_Project_Details(this.Project_ID, this.Status, this.ID).then((result: any) => {
                    if (result) {
                        this._toastrService.displayToastrMessage('success', 'Project details deleted successfully', 'Delete Project Details!')
                        this.Get_All_Projects_With_Details();
                    } else {
                        this._toastrService.displayToastrMessage('error', 'Error occured while processing your request', 'Delete Project Details!')
                    }

                });
            }
        }));
    }
    ngOnInit(): void {
        this.Is_Processing = true;
        localStorage.removeItem('P_ID');
        this.Selected_project_ID = 0;
        this.Get_All_Projects_With_Details();
    }
    ngOnDestroy(): void { }
    OpenProjectDetails(val: any) {
        if (this.Is_Details_Show) {
            this.Is_Details_Show = false;
            this.Selected_project_ID = 0
        }
        else {
            this.Is_Details_Show = true;
            this.Selected_project_ID = val
        }
    }
    public Get_All_Projects_With_Details(): Promise<any> {
        //this.All_Projects_With_Details = [] as []; // why is this necessary?
        return this._ProjectService.Get_All_Projects_With_Details().then((result: any) => {
            this.All_Projects_With_Details = result;
            this.Is_Processing = false;
        });
    }
    public DeleteProjectDetail(Project_ID: any, Status: any, ID: any): void {
        this.Project_ID = Project_ID;
        this.Status = Status;
        this.ID = ID;
        this._globalService.confirmDelete('Project Details', this.Status, this.Project_ID);
    }
    public ShowModalPublishProject(Project_ID: any, Project_Title: any): void {
        this.Project_ID = Project_ID;
        this.Project_Title = Project_Title;
        this.modal.show();
    }
    public PublishProject() {
        return this._ProjectService.Publish_Project_Details().then((result: any) => {
            if (result) {
                this._toastrService.displayToastrMessage('success', 'Changes published successfully', 'Publish Changes!');
                this.modal.hide();
                //this.Get_All_Projects_With_Details();
            } else {
                this._toastrService.displayToastrMessage('error', 'Error occured while processing your request', 'Publish Changes!')
            }
        });
    }
    public DeleteProject(Project_ID: any, Project_Title: any): void {
        this.Project_ID = Project_ID;
        this.Project_Title = Project_Title;
        this.ModelDeleteProject.show();
    }
    public DeleteSelectedProject() {
        return this._ProjectService.Delete_Project(this.Project_ID).then((result: any) => {
            if (result) {
                this._toastrService.displayToastrMessage('success', 'Project deleted successfully', 'Delete Project!')
                this.ModelDeleteProject.hide();
                this.Get_All_Projects_With_Details();
            } else {
                this._toastrService.displayToastrMessage('error', 'Error occured while processing your request', 'Delete Project!')
            }
        });
    }
    public Close(): void {
        this.ModelDeleteProject.hide();
        this.modal.hide();
    }
}
